import {
  FuelCapacityUpdateBody, FuelConsumptionTypeUpdateBody, FuelStopSuggestionsUpdateBody, FuelUnitUpdateBody, SetupRequestUpdate, SmartConnectVehicle, VehicleApi, VehicleSeedOdometerUpdateRequest, // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import { AxiosPromise, AxiosResponse } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath() + '/my-trips'

export default class ExtendedVehicleApi extends VehicleApi {
  setSetup (vehicleId: number, request: SetupRequestUpdate, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.setSetup(vehicleId, request, undefined, options)
  }

  getSmartConnectVehicles (options?: any): AxiosPromise<Array<SmartConnectVehicle>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getSmartConnectVehicles(undefined, options)
  }

  setSeedOdometer (vehicleId: number, requestBody: VehicleSeedOdometerUpdateRequest, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.setSeedOdometer(vehicleId, requestBody, undefined, options)
  }

  setFuelConsumptionType (vehicleId: number, requestBody: FuelConsumptionTypeUpdateBody, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.setFuelConsumptionType(vehicleId, requestBody, undefined, options)
  }

  setFuelUnit (vehicleId: number, requestBody: FuelUnitUpdateBody, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.setFuelUnit(vehicleId, requestBody, undefined, options)
  }

  setFuelCapacity (vehicleId: number, requestBody: FuelCapacityUpdateBody, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.setFuelCapacity(vehicleId, requestBody, undefined, options)
  }

  setFuelStopSuggestions (vehicleId: number, requestBody: FuelStopSuggestionsUpdateBody, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.toggleFuelStopSuggestions(vehicleId, requestBody, undefined, options)
  }
}
